import {EventBase} from "shared/utilities/Events/EventManager";
import {PropertyBase} from "../pagebuilder/Controls/Properties/PropertyBase";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";





export class ItemDeleted extends EventBase {
    ReturnType: PDFControlBase;

    constructor(public Item:PDFControlBase)
    {
        super();
    }

    public static GetName() {
        return 'ItemDeleted';
    }
}